import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-002a3def")
const _hoisted_1 = { class: "modal" }
_popScopeId()

import Template from '@/components/lesson-plan-editor/components/Template'
import { useStore } from 'vuex'
import { computed } from 'vue'


export default {
  props: {
  node: {
    type: Object,
    default: () => null
  }
},
  emits: ['ok'],
  setup(__props, { emit }) {

const props = __props


const store = useStore()



const courseNode = computed(() => props.node)

const handleCreate = () => {
  emit('ok')
}


return (_ctx, _cache) => {
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    footer: null,
    width: "1000px",
    onCancel: handleCreate
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", {
        class: "modalTitle",
        style: _normalizeStyle({borderColor: _unref(store).state.themeColor})
      }, " 选择教案模板 ", 4)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Template), {
          onHandleCreate: handleCreate,
          onHandleEdit: handleCreate,
          templateContent: _ctx.templateContent,
          node: _unref(courseNode)
        }, null, 8, ["templateContent", "node"])
      ])
    ]),
    _: 1
  }))
}
}

}